import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RelatedProducts = ({ products }) => {
  const navigate = useNavigate();

  const handleProductClick = (productId) => {
    navigate(`/product-detail-page?id=${productId}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="p-6 md:p-8 rounded-xl bg-card border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-secondary/10 border border-secondary/30 flex items-center justify-center">
          <Icon name="Sparkles" size={20} color="var(--color-secondary)" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground">
          Related Products
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {products?.map((product) => (
          <div
            key={product?.id}
            className="group p-4 rounded-xl bg-muted/50 border border-border transition-all duration-250 hover:bg-card hover:border-primary hover:shadow-lg hover:shadow-primary/20 cursor-pointer"
            onClick={() => handleProductClick(product?.id)}
          >
            <div className="aspect-square rounded-lg overflow-hidden mb-4 bg-card">
              <Image
                src={product?.image}
                alt={product?.imageAlt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
            </div>

            <div className="space-y-2">
              <span className="inline-block px-2 py-1 rounded bg-primary/10 border border-primary/30 text-primary text-xs font-medium caption">
                {product?.category}
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground line-clamp-2">
                {product?.name}
              </h3>
              <p className="text-sm text-muted-foreground line-clamp-2">
                {product?.description}
              </p>

              <div className="flex items-center justify-between pt-2">
                <span className="text-xl md:text-2xl font-bold text-primary data-text">
                  ${product?.price}
                </span>
                <div className="flex items-center gap-1">
                  <Icon name="Star" size={14} color="var(--color-accent)" className="fill-accent" />
                  <span className="text-sm text-foreground data-text">
                    {product?.rating}
                  </span>
                </div>
              </div>

              <Button
                variant="outline"
                size="sm"
                fullWidth
                iconName="Eye"
                iconPosition="left"
                onClick={(e) => {
                  e?.stopPropagation();
                  handleProductClick(product?.id);
                }}
              >
                View Details
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;